import {chainWalk} from "../../../util/Util";
import {formatAisleLabel, getDisplayableColumnLabel} from "../../../util/LidarTesterUtil";
import {LIDAR_TESTER_SENSOR_STATES} from "../../../util/Constants";

export const LidarTesterReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_STATE_MAP":
            return {...state, ...{sensorStateMap: createMap(action.data.sortedAssetByAisle),
                    controllerMacAddress: action.data.macAddress, columnsList: action.data.columnsList}}
        case "UPDATE_STATE_MAP":
            let columnLabel = state.columnsList.filter(col => col.includes(action.data.message.columnLabel))
            let aisleLabel = formatAisleLabel(action.data.message.aisleLabel)
            if (chainWalk(() => getSensorState(state.sensorStateMap, action.data.message, columnLabel, aisleLabel), false)) {
                state.sensorStateMap[aisleLabel][columnLabel][action.data.message.address][action.data.message.sensorIndex.toString()] = {
                    ...getUpdatedSensorState(action.data.message.timestamp,
                        action.data.message.tier,
                        action.data.message.columnLabel)
                };
            }
            return {...state}
        default:
            return state
    }
}

const getUpdatedSensorState = (timestamp, tier, columnLabel) => {
    return {
        state: LIDAR_TESTER_SENSOR_STATES.STOW_DETECTED,
        time: timestamp,
        value: tier !== -1 ? tier : columnLabel
    }
}

const getSensorState = (sensorStateMap, message, columnLabel, aisleLabel) => {
    return sensorStateMap[aisleLabel][columnLabel][message.address][message.sensorIndex.toString()];
}

export const initialSensorState = {
    state: LIDAR_TESTER_SENSOR_STATES.DEFAULT,
    time: Date.now(),
    value: ""
}

const createMap = (sortedAsset) => {
    let map = {}
    if (sortedAsset) {
        sortedAsset.forEach((assetMapping) => {
            const aisleLabel = formatAisleLabel(assetMapping.aisleLabel)
            map[aisleLabel] = {}
            assetMapping.columns.forEach((column) => {
                let columnLabel = getDisplayableColumnLabel(column.columnLabel, column.rowLabels);
                map[aisleLabel][columnLabel] = map[aisleLabel][columnLabel]
                    ? map[aisleLabel][columnLabel] : {}
                map[aisleLabel][columnLabel][column.columnAddress] = {}
                map[aisleLabel][columnLabel][column.columnAddress]["0"] = initialSensorState
                map[aisleLabel][columnLabel][column.columnAddress]["1"] = initialSensorState
            })
        });
    }
    return map
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/reducer/LidarTesterReducer.js